import classNames from 'classnames'
import React, { FC } from 'react'
import { DivBtn } from '../generic/DivBtn'
import { SvgCross } from '../generic/SvgCross'

export const DeleteEventButton: FC<{ onClick: (skipConfirm: boolean) => void }> = ({ onClick }) => {
    return (
        <DivBtn onClick={(modifier) => onClick(modifier.shiftKey)}>
            <div
                style={{ width: 40 }}
                className={classNames(
                    "border-left d-flex align-items-center justify-content-center"
                )}
            >
                <SvgCross />
            </div>
        </DivBtn>
    )
}
